import React from 'react';
import { Row, Col } from 'shards-react';

import './_document-page.css';

const DocumentPage = props => {
  const { page } = props;
  return (
    <Row className="document-body">
      <Col>
        <iframe src={page} title="document" />
      </Col>
    </Row>
  );
};

export default DocumentPage;
